// data/items/petFood.js
// Pet food items gathered from Gatherer skill zones

export const PET_FOOD = [
    // Tier 1 - Basic pet food (from tier 1 zones)
    {
        id: 'basic_pet_food',
        name: 'Basic Pet Food',
        color: '#8b7355',
        tier: 1,
        feedValue: 10,
        description: 'Simple sustenance for fledgling companions.',
        value: 5
    },
    // Tier 2 - Refined pet food (from tier 2 zones)
    {
        id: 'refined_pet_food',
        name: 'Refined Pet Food',
        color: '#6b8e6b',
        tier: 2,
        feedValue: 25,
        description: 'Nutrient-rich feed that accelerates pet growth.',
        value: 22
    },
    // Tier 3 - Condensed pet food (from tier 3 zones)
    {
        id: 'condensed_pet_food',
        name: 'Condensed Pet Food',
        color: '#9370db',
        tier: 3,
        feedValue: 50,
        description: 'Concentrated essence of planar flora for apex companions.',
        value: 52
    }
];

export default PET_FOOD;
